var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"border-bottom pt-3 pb-3 mb-4"},[_vm._v(" 404 Not Found"),_c('br'),_vm._v("該当するページが見つかりませんでした。 ")])])}]

export { render, staticRenderFns }